/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Vekn_LabelInputs */



/**
* | output |
* | --- |
* | "Sync VEKN members" |
*
* @param {Admin_Sync_Vekn_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_vekn_label = /** @type {((inputs?: Admin_Sync_Vekn_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Vekn_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchroniser les membres VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizar miembros de VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronizar membros do VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizza i membri VEKN")
	return /** @type {LocalizedString} */ ("Sync VEKN members")
});